import { axios } from '@/utils/request'

const api = {
    getPaymentList: '/5e494b24cc4b0',
    add: '/5e494787baa30',
    bind: '/5e494a4bcd081',
    delete: '/5e494d0f36e50',
    cancelBind: '/5e494a4bcd081',
    addHxwlAccount: '/6389be4b10732',
}

export default {
    // 获取列表
    getPaymentList: (parameter) => {
        const params = Object.assign(parameter, {
            page: parameter.pageNo || 1,
            size: parameter.pageSize || 20
        })
        return axios({
            url: api.getPaymentList,
            method: 'get',
            params: params
        }).then(res => {
            return {
                data: res.data.list || [],
                pageNo: parameter.pageNo,
                pageSize: parameter.pageSize,
                totalCount: res.data.count
            }
        })
    }, 
    // 新增
    add: (parameter) => {
        return axios({
            url: api.add,
            method: 'post',
            data: parameter
        })
    },
    // 关联机器人
    bind: (parameter) => {
        return axios({
            url: api.bind,
            method: 'post',
            data: parameter
        })
    },
    // 删除API密钥
    delete: (parameter) => {
        return axios({
            url: api.delete,
            method: 'post',
            data: parameter
        })
    },
    // 取消关联机器人
    cancelBind: (parameter) => {
        return axios({
            url: api.cancelBind,
            method: 'post',
            data: parameter
        })
    },
    // 注册欢喜物流账号
    addHxwlAccount: (parameter) => {
        return axios({
            url: api.addHxwlAccount,
            method: 'post',
            data: parameter
        })
    }
}
